<div class="field-container">
  @if (props['label']) {
  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
  <label class="field-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }

  @if (props['description']) {
  <p class="field-description">{{ props['description'] }}</p>
  }

  <!-- Dropdown wrapper — provides the positioning context for the panel -->
  <div class="dropdown-wrapper" [class.is-open]="isOpen()">

    <!-- Trigger button -->
    <button type="button" class="dropdown-trigger" [class.has-value]="selectedLabel !== null" [class.is-open]="isOpen()"
      (click)="toggleOpen()" [attr.data-testid]="'field-dropdown-trigger'">
      @if (selectedLabel !== null) {
      <span class="trigger-label">{{ selectedLabel }}</span>
      } @else {
      <span class="trigger-placeholder">{{ placeholder }}</span>
      }
      <app-icon name="chevron-down" class="trigger-chevron" [class.rotated]="isOpen()" />
    </button>

    <!-- Option panel (shown when open) -->
    @if (isOpen()) {
    <div class="dropdown-panel" [attr.data-testid]="'field-dropdown-panel'">
      @for (option of dropdownOptions; track option.value) {
      <button type="button" class="dropdown-option" [class.selected]="isSelected(option.value)"
        (click)="selectOption(option.value)" [attr.data-testid]="'field-dropdown-option-' + option.value">
        <div class="option-content">
          <span class="option-label">{{ option.label }}</span>
          @if (option.description) {
          <span class="option-description">{{ option.description }}</span>
          }
        </div>
        @if (isSelected(option.value)) {
        <app-icon name="check" class="check-icon" />
        }
      </button>
      }

      @if (dropdownOptions.length === 0) {
      <div class="dropdown-empty">No options available</div>
      }
    </div>
    }
  </div>

  @if (formControl.touched && formControl.errors) {
  <div class="field-error" [attr.data-testid]="'field-dropdown-error'">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>